module.exports = __webpack_public_path__ + "static/img/組織架構.png";